import { gql } from "@apollo/client";

const DeleteUserProjectMutation = gql`
  mutation DeleteUserProjectMutation($id: BigInt!) {
    deleteUserProjectById(input: { id: $id }) {
      deletedUserProjectId
    }
  }
`;

const hash = "a935e356c98ee67a66e75a88347ff48dffde795a0bc056058b242873a3c93399";
export { DeleteUserProjectMutation, hash };
